import axios_api from "src/api/axios";

class UploadAdapter {
    constructor(loader) {
      this.loader = loader;
    }
  
    // Starts the upload process.
    async upload() {
      this.loader.uploaded = 0;
      this.loader.uploadTotal = 0;
  
      try {
        if (this.loader.file) {
          const file = await this.loader.file;
          const formData = new FormData();
          formData.append('file', file);
  
          const response = await axios_api.post('/account/texteditor-doc/', formData, {
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.loader.uploadTotal = progressEvent.total;
                this.loader.uploaded = progressEvent.loaded;
              }
            }
          });
  
          if (response.data.error) {
            throw new Error("Unable to upload file");
          }
  
          return {
            default: response.data.location,
          };
        }
      } catch (error) {
        throw new  Error("Unable to upload file");
      }
    }
  
    // Aborts the upload process.
    abort() {
      if (this.source) {
        this.source.cancel('Upload canceled by the user.');
      }
    }
  }
  
  export default UploadAdapter;